export default {
    commentPlaceholder: 'Comment on this actuality',
    comment: 'comment',
    comments: {
        less: 'See less comments',
        more: 'See all comments'
    },
    dateText: 'Posted on the :DATE',
    likes: 'Like',
    share: 'Share',
    toComment: 'Comment',
}